module.exports = __webpack_public_path__ + "static/media/icon_201.1fef33c2.svg";